module.exports = __webpack_public_path__ + "media/newstyle/images/icon-arrow-down-purple-orange-4d5f59be6dc22efa88e2b76731e40072.svg";